import axios from 'axios';

const instance = config =>
  axios.create({
    timeout: 120000,
    //  withCredentials: true,

    transformRequest: [
      (data, headers) => {
        if (!data) {
          return '';
        }
        if (headers['Content-Type'] === 'multipart/form-data') {
          const formData = new FormData();
          formData.append('documentData', data);
          return formData;
        } else {
          return JSON.stringify(data.data);
        }
      },
    ],
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
    ...config,
  });

export default instance;
